import { FC, useEffect } from 'react'
import { useLocation } from 'react-router'

import { useModal } from '@app/context/ModalsContext'

import { TradingAccount } from '@model/TradingAccount'

import { safeSessionStorage } from '@hooks/useStorage'

import { SwapFreeInfoModal } from '../modals/SwapFreeInfo.modal'
import { SwapFree } from './SwapFree'

interface SwapFreeContainerProps {
  tradingAccount: TradingAccount
  isFullWidth?: boolean
  onContactSupport: () => void
}

export const SwapFreeContainer: FC<SwapFreeContainerProps> = ({
  tradingAccount,
  isFullWidth,
  onContactSupport,
}) => {
  const location = useLocation()

  const swapFreeInfoModal = useModal(SwapFreeInfoModal, {
    tradingAccount,
  })

  const { isSuspendedFromSwapFree } = tradingAccount

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const tradingAccountParam = params.get('tradingAccountId')
    const storageKey = `swap-free-modal-${tradingAccountParam}`

    if (
      tradingAccountParam &&
      tradingAccountParam === tradingAccount.id &&
      !isSuspendedFromSwapFree
    ) {
      if (!safeSessionStorage.getItem(storageKey)) {
        swapFreeInfoModal.open()
        safeSessionStorage.setItem(storageKey, 'opened')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tradingAccount.id, location.search, location.pathname, isSuspendedFromSwapFree])

  const handleOpenSwapFreeInfoModal = () => {
    if (isSuspendedFromSwapFree) return
    swapFreeInfoModal.open()
  }

  return (
    <SwapFree
      tradingAccount={tradingAccount}
      isFullWidth={isFullWidth}
      swapFreeIsDisabled={isSuspendedFromSwapFree}
      onContactSupport={onContactSupport}
      onOpenInfoModal={handleOpenSwapFreeInfoModal}
    />
  )
}
